import React from 'react'

import './ContactInfo.css'

export const ContactInfo = ({ fourthWall }) => {
  return (
    <div className="ContactInfo--Container">
      <div className="Contact--Item">
        <header className="Contact--Item--Header">
          <h2>Have an interesting project?</h2>
        </header>
        <p>Send an email to:</p>
        <p>
          <span className="underline">
            <a href="mailto:praise@philemo-nn.com">praise@philemo-nn.com</a>
          </span>
          <span className="underline">
            <a href="mailto:work@philemo-nn.com">work@philemo-nn.com</a>
          </span>
        </p>
      </div>
      <div className="Contact--Item">
        <header className="Contact--Item--Header">
          <h2>Looking for a team?</h2>
        </header>
        <p>Send your resume to:</p>
        <p>
          <span className="underline">
            <a href="mailto:praise@philemo-nn.com">praise@philemo-nn.com</a>
          </span>
        </p>
      </div>
      <div className="Contact--Item">
        <header className="Contact--Item--Header">
          <h2>Mailing Address.</h2>
        </header>
        <p>Tunde Oluwayomi St., Alagbaka GRA, Akure.</p>
        <p>
          <span className="underline">
            <a href="tel:+234 (818) 099-2590">+234 (818) 099-2590</a>
          </span>
        </p>
      </div>
      {fourthWall && (
        <div className="Contact--Item">
          <header className="Contact--Item--Header">
            <h2>Say hi!</h2>
          </header>
          <p>Send an email to:</p>
          <p>
            <span className="underline">
              <a href="mailto:work@philemo-nn.com">work@philemo-nn.com</a>
            </span>
          </p>
        </div>
      )}
    </div>
  )
}

export default ContactInfo
